<div class="container-fuid bg-white default-boxrounded" [attr.data-testid]="'editSendgroupDataModal'">
  <div class="col-12 w-100">
    <h3 class="title col-9">
      <span translate="Modals.SendgroupEditName.Title"></span>
    </h3>
  </div>
  <div class="p-4 pt-0">
    <form class="row needs-validation has-validation" [formGroup]="form" (ngSubmit)="save()">
      <div class="mb-3">
        <label for="name" class="form-label" translate="Modals.SendgroupEditName.SendGroupName"></label>
        <input type="text" id="name" formControlName="name" class="form-control" [value]="sendgroupToUpdate.sendGroupName"
          [attr.data-testid]="'sendgroupName'" />
          <app-formcontrol-error-messages [forControl]="nameValue"></app-formcontrol-error-messages>

          <label for="sendGroupDeadline" class="form-label mt-3" translate="Request.Send.Deadline"></label>
          @if (sendgroupToUpdate.allowedToChangeDeadline) {
            <datetime-picker (changeDateEmit)="changeDeadline($event)" [previousDeadlineDate]="sendgroupToUpdate.deadline!" [attr.data-testid]="'sendgroupDeadlineDate'"></datetime-picker>
          }
          @if (sendgroupToUpdate.allowedToChangeDeadlineDays) {
            <div ngbDropdown class="col-12 float-start dropdown" ngDefaultControl name="deadline" id="deadline">
              <button class="btn default deadlineDays dropdown-toggle text-truncate" type="button" id="dropdownMenu"
                ngbDropdownToggle>
                @if (sendgroupToUpdate.deadlineDays === 1) {
                  <span translate="Request.Send.DeadlineDay"
                  [translateParams]="{days: sendgroupToUpdate.deadlineDays}"></span>
                }
                @if (sendgroupToUpdate.deadlineDays && sendgroupToUpdate.deadlineDays > 1 && sendgroupToUpdate.deadlineDays < 31) {
                  <span translate="Request.Send.DeadlineDays"
                  [translateParams]="{days: sendgroupToUpdate.deadlineDays}"></span>
                }
                @if (sendgroupToUpdate.deadlineDays === 31) {
                  <span translate="Request.Send.DeadlineMonth"
                  [translateParams]="{month: 1}"></span>
                }
                @if (sendgroupToUpdate.deadlineDays && sendgroupToUpdate.deadlineDays > 31) {
                  <span translate="Request.Send.DeadlineMonths"
                  [translateParams]="{months: sendgroupToUpdate.deadlineDays === 62 ? 2 : 3}"></span>
                }
                <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
              </button>
              <div class="dropdownMenuTime col-12 actions-dropdown" ngbDropdownMenu aria-labelledby="dropdownMenu">
                @for (days of [1, 2, 3, 4, 5, 6, 7, 10, 14, 21, 31, 62, 93]; track days) {
                  <button ngbDropdownItem
                    value={{days}} (click)="updateDeadlineDays(days)">
                    @if (days === 1) {
                      <span translate=Request.Send.DeadlineDay
                      [translateParams]="{days: days}"></span>
                    }
                    @if (days > 1 && days < 31) {
                      <span translate="Request.Send.DeadlineDays"
                      [translateParams]="{days: days}"></span>
                    }
                    @if (days === 31) {
                      <span translate="Request.Send.DeadlineMonth"
                      [translateParams]="{month: 1}"></span>
                    }
                    @if (days > 31) {
                      <span translate="Request.Send.DeadlineMonths"
                      [translateParams]="{months: days === 62 ? 2 : 3}"></span>
                    }
                  </button>
                }
              </div>
            </div>
          }
        </div>
        <div class="col-12 mt-4 pb-2 d-table w-100">
          <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="closeModal()" translate="Button.Back" [attr.data-testid]="'backButton'"></button></span>
          <span class="float-end"><button type="submit" class="btn btn-sm btn-primary" translate="Button.Confirm" [attr.data-testid]="'confirmButton'"></button></span>
        </div>
      </form>
    </div>
  </div>